module.exports = __webpack_public_path__ + "media/images/icons/graph-96895cfcab69b763c16ccce3ce43f517.svg";